
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaccd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaccd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7bTWQ", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $17tgv = parcelRequire("17tgv");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem("debug", namespaces);
        else exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $17tgv !== "undefined" && "env" in $17tgv) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("c4X4n"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRegister("17tgv", function(module, exports) {
// shim for using process in browser
var $0d0d255e14f785b6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0d0d255e14f785b6$var$cachedSetTimeout;
var $0d0d255e14f785b6$var$cachedClearTimeout;
function $0d0d255e14f785b6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $0d0d255e14f785b6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        else $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        else $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    }
})();
function $0d0d255e14f785b6$var$runTimeout(fun) {
    if ($0d0d255e14f785b6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedSetTimeout === $0d0d255e14f785b6$var$defaultSetTimout || !$0d0d255e14f785b6$var$cachedSetTimeout) && setTimeout) {
        $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0d0d255e14f785b6$var$runClearTimeout(marker) {
    if ($0d0d255e14f785b6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedClearTimeout === $0d0d255e14f785b6$var$defaultClearTimeout || !$0d0d255e14f785b6$var$cachedClearTimeout) && clearTimeout) {
        $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0d0d255e14f785b6$var$queue = [];
var $0d0d255e14f785b6$var$draining = false;
var $0d0d255e14f785b6$var$currentQueue;
var $0d0d255e14f785b6$var$queueIndex = -1;
function $0d0d255e14f785b6$var$cleanUpNextTick() {
    if (!$0d0d255e14f785b6$var$draining || !$0d0d255e14f785b6$var$currentQueue) return;
    $0d0d255e14f785b6$var$draining = false;
    if ($0d0d255e14f785b6$var$currentQueue.length) $0d0d255e14f785b6$var$queue = $0d0d255e14f785b6$var$currentQueue.concat($0d0d255e14f785b6$var$queue);
    else $0d0d255e14f785b6$var$queueIndex = -1;
    if ($0d0d255e14f785b6$var$queue.length) $0d0d255e14f785b6$var$drainQueue();
}
function $0d0d255e14f785b6$var$drainQueue() {
    if ($0d0d255e14f785b6$var$draining) return;
    var timeout = $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$cleanUpNextTick);
    $0d0d255e14f785b6$var$draining = true;
    var len = $0d0d255e14f785b6$var$queue.length;
    while(len){
        $0d0d255e14f785b6$var$currentQueue = $0d0d255e14f785b6$var$queue;
        $0d0d255e14f785b6$var$queue = [];
        while(++$0d0d255e14f785b6$var$queueIndex < len)if ($0d0d255e14f785b6$var$currentQueue) $0d0d255e14f785b6$var$currentQueue[$0d0d255e14f785b6$var$queueIndex].run();
        $0d0d255e14f785b6$var$queueIndex = -1;
        len = $0d0d255e14f785b6$var$queue.length;
    }
    $0d0d255e14f785b6$var$currentQueue = null;
    $0d0d255e14f785b6$var$draining = false;
    $0d0d255e14f785b6$var$runClearTimeout(timeout);
}
$0d0d255e14f785b6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0d0d255e14f785b6$var$queue.push(new $0d0d255e14f785b6$var$Item(fun, args));
    if ($0d0d255e14f785b6$var$queue.length === 1 && !$0d0d255e14f785b6$var$draining) $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$drainQueue);
};
// v8 likes predictible objects
function $0d0d255e14f785b6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0d0d255e14f785b6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0d0d255e14f785b6$var$process.title = "browser";
$0d0d255e14f785b6$var$process.browser = true;
$0d0d255e14f785b6$var$process.env = {};
$0d0d255e14f785b6$var$process.argv = [];
$0d0d255e14f785b6$var$process.version = ""; // empty string to avoid regexp issues
$0d0d255e14f785b6$var$process.versions = {};
function $0d0d255e14f785b6$var$noop() {}
$0d0d255e14f785b6$var$process.on = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.addListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.once = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.off = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeAllListeners = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.emit = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependOnceListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.listeners = function(name) {
    return [];
};
$0d0d255e14f785b6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$0d0d255e14f785b6$var$process.cwd = function() {
    return "/";
};
$0d0d255e14f785b6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$0d0d255e14f785b6$var$process.umask = function() {
    return 0;
};

});

parcelRegister("c4X4n", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $8cb3adc472fdaeb7$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("1gU9v"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $8cb3adc472fdaeb7$var$setup;

});
parcelRegister("1gU9v", function(module, exports) {
/**
 * Helpers.
 */ var $0ed2d7c0f76098e8$var$s = 1000;
var $0ed2d7c0f76098e8$var$m = $0ed2d7c0f76098e8$var$s * 60;
var $0ed2d7c0f76098e8$var$h = $0ed2d7c0f76098e8$var$m * 60;
var $0ed2d7c0f76098e8$var$d = $0ed2d7c0f76098e8$var$h * 24;
var $0ed2d7c0f76098e8$var$w = $0ed2d7c0f76098e8$var$d * 7;
var $0ed2d7c0f76098e8$var$y = $0ed2d7c0f76098e8$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $0ed2d7c0f76098e8$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $0ed2d7c0f76098e8$var$fmtLong(val) : $0ed2d7c0f76098e8$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $0ed2d7c0f76098e8$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $0ed2d7c0f76098e8$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $0ed2d7c0f76098e8$var$w;
        case "days":
        case "day":
        case "d":
            return n * $0ed2d7c0f76098e8$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $0ed2d7c0f76098e8$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $0ed2d7c0f76098e8$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $0ed2d7c0f76098e8$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $0ed2d7c0f76098e8$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $0ed2d7c0f76098e8$var$d) return Math.round(ms / $0ed2d7c0f76098e8$var$d) + "d";
    if (msAbs >= $0ed2d7c0f76098e8$var$h) return Math.round(ms / $0ed2d7c0f76098e8$var$h) + "h";
    if (msAbs >= $0ed2d7c0f76098e8$var$m) return Math.round(ms / $0ed2d7c0f76098e8$var$m) + "m";
    if (msAbs >= $0ed2d7c0f76098e8$var$s) return Math.round(ms / $0ed2d7c0f76098e8$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $0ed2d7c0f76098e8$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $0ed2d7c0f76098e8$var$d) return $0ed2d7c0f76098e8$var$plural(ms, msAbs, $0ed2d7c0f76098e8$var$d, "day");
    if (msAbs >= $0ed2d7c0f76098e8$var$h) return $0ed2d7c0f76098e8$var$plural(ms, msAbs, $0ed2d7c0f76098e8$var$h, "hour");
    if (msAbs >= $0ed2d7c0f76098e8$var$m) return $0ed2d7c0f76098e8$var$plural(ms, msAbs, $0ed2d7c0f76098e8$var$m, "minute");
    if (msAbs >= $0ed2d7c0f76098e8$var$s) return $0ed2d7c0f76098e8$var$plural(ms, msAbs, $0ed2d7c0f76098e8$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $0ed2d7c0f76098e8$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});




var $7bTWQ = parcelRequire("7bTWQ");
var $0785d02662dc2fe7$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $0785d02662dc2fe7$var$INFINITY = 1 / 0, $0785d02662dc2fe7$var$MAX_SAFE_INTEGER = 9007199254740991, $0785d02662dc2fe7$var$MAX_INTEGER = 1.7976931348623157e+308, $0785d02662dc2fe7$var$NAN = 0 / 0;
/** Used as references for the maximum length and index of an array. */ var $0785d02662dc2fe7$var$MAX_ARRAY_LENGTH = 4294967295;
/** `Object#toString` result references. */ var $0785d02662dc2fe7$var$argsTag = "[object Arguments]", $0785d02662dc2fe7$var$funcTag = "[object Function]", $0785d02662dc2fe7$var$genTag = "[object GeneratorFunction]", $0785d02662dc2fe7$var$mapTag = "[object Map]", $0785d02662dc2fe7$var$objectTag = "[object Object]", $0785d02662dc2fe7$var$promiseTag = "[object Promise]", $0785d02662dc2fe7$var$setTag = "[object Set]", $0785d02662dc2fe7$var$stringTag = "[object String]", $0785d02662dc2fe7$var$symbolTag = "[object Symbol]", $0785d02662dc2fe7$var$weakMapTag = "[object WeakMap]";
var $0785d02662dc2fe7$var$dataViewTag = "[object DataView]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $0785d02662dc2fe7$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match leading and trailing whitespace. */ var $0785d02662dc2fe7$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $0785d02662dc2fe7$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0785d02662dc2fe7$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect host constructors (Safari). */ var $0785d02662dc2fe7$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect octal string values. */ var $0785d02662dc2fe7$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $0785d02662dc2fe7$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to compose unicode character classes. */ var $0785d02662dc2fe7$var$rsAstralRange = "\ud800-\udfff", $0785d02662dc2fe7$var$rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23", $0785d02662dc2fe7$var$rsComboSymbolsRange = "\\u20d0-\\u20f0", $0785d02662dc2fe7$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $0785d02662dc2fe7$var$rsAstral = "[" + $0785d02662dc2fe7$var$rsAstralRange + "]", $0785d02662dc2fe7$var$rsCombo = "[" + $0785d02662dc2fe7$var$rsComboMarksRange + $0785d02662dc2fe7$var$rsComboSymbolsRange + "]", $0785d02662dc2fe7$var$rsFitz = "\ud83c[\udffb-\udfff]", $0785d02662dc2fe7$var$rsModifier = "(?:" + $0785d02662dc2fe7$var$rsCombo + "|" + $0785d02662dc2fe7$var$rsFitz + ")", $0785d02662dc2fe7$var$rsNonAstral = "[^" + $0785d02662dc2fe7$var$rsAstralRange + "]", $0785d02662dc2fe7$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $0785d02662dc2fe7$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $0785d02662dc2fe7$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $0785d02662dc2fe7$var$reOptMod = $0785d02662dc2fe7$var$rsModifier + "?", $0785d02662dc2fe7$var$rsOptVar = "[" + $0785d02662dc2fe7$var$rsVarRange + "]?", $0785d02662dc2fe7$var$rsOptJoin = "(?:" + $0785d02662dc2fe7$var$rsZWJ + "(?:" + [
    $0785d02662dc2fe7$var$rsNonAstral,
    $0785d02662dc2fe7$var$rsRegional,
    $0785d02662dc2fe7$var$rsSurrPair
].join("|") + ")" + $0785d02662dc2fe7$var$rsOptVar + $0785d02662dc2fe7$var$reOptMod + ")*", $0785d02662dc2fe7$var$rsSeq = $0785d02662dc2fe7$var$rsOptVar + $0785d02662dc2fe7$var$reOptMod + $0785d02662dc2fe7$var$rsOptJoin, $0785d02662dc2fe7$var$rsSymbol = "(?:" + [
    $0785d02662dc2fe7$var$rsNonAstral + $0785d02662dc2fe7$var$rsCombo + "?",
    $0785d02662dc2fe7$var$rsCombo,
    $0785d02662dc2fe7$var$rsRegional,
    $0785d02662dc2fe7$var$rsSurrPair,
    $0785d02662dc2fe7$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $0785d02662dc2fe7$var$reUnicode = RegExp($0785d02662dc2fe7$var$rsFitz + "(?=" + $0785d02662dc2fe7$var$rsFitz + ")|" + $0785d02662dc2fe7$var$rsSymbol + $0785d02662dc2fe7$var$rsSeq, "g");
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $0785d02662dc2fe7$var$reHasUnicode = RegExp("[" + $0785d02662dc2fe7$var$rsZWJ + $0785d02662dc2fe7$var$rsAstralRange + $0785d02662dc2fe7$var$rsComboMarksRange + $0785d02662dc2fe7$var$rsComboSymbolsRange + $0785d02662dc2fe7$var$rsVarRange + "]");
/** Built-in method references without a dependency on `root`. */ var $0785d02662dc2fe7$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $0785d02662dc2fe7$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $0785d02662dc2fe7$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $0785d02662dc2fe7$var$root = $0785d02662dc2fe7$var$freeGlobal || $0785d02662dc2fe7$var$freeSelf || Function("return this")();
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $0785d02662dc2fe7$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0785d02662dc2fe7$var$asciiToArray(string) {
    return string.split("");
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $0785d02662dc2fe7$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $0785d02662dc2fe7$var$baseValues(object, props) {
    return $0785d02662dc2fe7$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $0785d02662dc2fe7$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $0785d02662dc2fe7$var$hasUnicode(string) {
    return $0785d02662dc2fe7$var$reHasUnicode.test(string);
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $0785d02662dc2fe7$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $0785d02662dc2fe7$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $0785d02662dc2fe7$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0785d02662dc2fe7$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $0785d02662dc2fe7$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0785d02662dc2fe7$var$stringToArray(string) {
    return $0785d02662dc2fe7$var$hasUnicode(string) ? $0785d02662dc2fe7$var$unicodeToArray(string) : $0785d02662dc2fe7$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0785d02662dc2fe7$var$unicodeToArray(string) {
    return string.match($0785d02662dc2fe7$var$reUnicode) || [];
}
/** Used for built-in method references. */ var $0785d02662dc2fe7$var$funcProto = Function.prototype, $0785d02662dc2fe7$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $0785d02662dc2fe7$var$coreJsData = $0785d02662dc2fe7$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $0785d02662dc2fe7$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($0785d02662dc2fe7$var$coreJsData && $0785d02662dc2fe7$var$coreJsData.keys && $0785d02662dc2fe7$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $0785d02662dc2fe7$var$funcToString = $0785d02662dc2fe7$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0785d02662dc2fe7$var$hasOwnProperty = $0785d02662dc2fe7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0785d02662dc2fe7$var$objectToString = $0785d02662dc2fe7$var$objectProto.toString;
/** Used to detect if a method is native. */ var $0785d02662dc2fe7$var$reIsNative = RegExp("^" + $0785d02662dc2fe7$var$funcToString.call($0785d02662dc2fe7$var$hasOwnProperty).replace($0785d02662dc2fe7$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $0785d02662dc2fe7$var$Symbol = $0785d02662dc2fe7$var$root.Symbol, $0785d02662dc2fe7$var$iteratorSymbol = $0785d02662dc2fe7$var$Symbol ? $0785d02662dc2fe7$var$Symbol.iterator : undefined, $0785d02662dc2fe7$var$propertyIsEnumerable = $0785d02662dc2fe7$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0785d02662dc2fe7$var$nativeFloor = Math.floor, $0785d02662dc2fe7$var$nativeKeys = $0785d02662dc2fe7$var$overArg(Object.keys, Object), $0785d02662dc2fe7$var$nativeRandom = Math.random;
/* Built-in method references that are verified to be native. */ var $0785d02662dc2fe7$var$DataView = $0785d02662dc2fe7$var$getNative($0785d02662dc2fe7$var$root, "DataView"), $0785d02662dc2fe7$var$Map = $0785d02662dc2fe7$var$getNative($0785d02662dc2fe7$var$root, "Map"), $0785d02662dc2fe7$var$Promise = $0785d02662dc2fe7$var$getNative($0785d02662dc2fe7$var$root, "Promise"), $0785d02662dc2fe7$var$Set = $0785d02662dc2fe7$var$getNative($0785d02662dc2fe7$var$root, "Set"), $0785d02662dc2fe7$var$WeakMap = $0785d02662dc2fe7$var$getNative($0785d02662dc2fe7$var$root, "WeakMap");
/** Used to detect maps, sets, and weakmaps. */ var $0785d02662dc2fe7$var$dataViewCtorString = $0785d02662dc2fe7$var$toSource($0785d02662dc2fe7$var$DataView), $0785d02662dc2fe7$var$mapCtorString = $0785d02662dc2fe7$var$toSource($0785d02662dc2fe7$var$Map), $0785d02662dc2fe7$var$promiseCtorString = $0785d02662dc2fe7$var$toSource($0785d02662dc2fe7$var$Promise), $0785d02662dc2fe7$var$setCtorString = $0785d02662dc2fe7$var$toSource($0785d02662dc2fe7$var$Set), $0785d02662dc2fe7$var$weakMapCtorString = $0785d02662dc2fe7$var$toSource($0785d02662dc2fe7$var$WeakMap);
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $0785d02662dc2fe7$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $0785d02662dc2fe7$var$isArray(value) || $0785d02662dc2fe7$var$isArguments(value) ? $0785d02662dc2fe7$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $0785d02662dc2fe7$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || $0785d02662dc2fe7$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $0785d02662dc2fe7$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $0785d02662dc2fe7$var$baseGetTag(value) {
    return $0785d02662dc2fe7$var$objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $0785d02662dc2fe7$var$baseIsNative(value) {
    if (!$0785d02662dc2fe7$var$isObject(value) || $0785d02662dc2fe7$var$isMasked(value)) return false;
    var pattern = $0785d02662dc2fe7$var$isFunction(value) || $0785d02662dc2fe7$var$isHostObject(value) ? $0785d02662dc2fe7$var$reIsNative : $0785d02662dc2fe7$var$reIsHostCtor;
    return pattern.test($0785d02662dc2fe7$var$toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0785d02662dc2fe7$var$baseKeys(object) {
    if (!$0785d02662dc2fe7$var$isPrototype(object)) return $0785d02662dc2fe7$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($0785d02662dc2fe7$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $0785d02662dc2fe7$var$baseRandom(lower, upper) {
    return lower + $0785d02662dc2fe7$var$nativeFloor($0785d02662dc2fe7$var$nativeRandom() * (upper - lower + 1));
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $0785d02662dc2fe7$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $0785d02662dc2fe7$var$getNative(object, key) {
    var value = $0785d02662dc2fe7$var$getValue(object, key);
    return $0785d02662dc2fe7$var$baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $0785d02662dc2fe7$var$getTag = $0785d02662dc2fe7$var$baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ($0785d02662dc2fe7$var$DataView && $0785d02662dc2fe7$var$getTag(new $0785d02662dc2fe7$var$DataView(new ArrayBuffer(1))) != $0785d02662dc2fe7$var$dataViewTag || $0785d02662dc2fe7$var$Map && $0785d02662dc2fe7$var$getTag(new $0785d02662dc2fe7$var$Map) != $0785d02662dc2fe7$var$mapTag || $0785d02662dc2fe7$var$Promise && $0785d02662dc2fe7$var$getTag($0785d02662dc2fe7$var$Promise.resolve()) != $0785d02662dc2fe7$var$promiseTag || $0785d02662dc2fe7$var$Set && $0785d02662dc2fe7$var$getTag(new $0785d02662dc2fe7$var$Set) != $0785d02662dc2fe7$var$setTag || $0785d02662dc2fe7$var$WeakMap && $0785d02662dc2fe7$var$getTag(new $0785d02662dc2fe7$var$WeakMap) != $0785d02662dc2fe7$var$weakMapTag) $0785d02662dc2fe7$var$getTag = function(value) {
    var result = $0785d02662dc2fe7$var$objectToString.call(value), Ctor = result == $0785d02662dc2fe7$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $0785d02662dc2fe7$var$toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case $0785d02662dc2fe7$var$dataViewCtorString:
            return $0785d02662dc2fe7$var$dataViewTag;
        case $0785d02662dc2fe7$var$mapCtorString:
            return $0785d02662dc2fe7$var$mapTag;
        case $0785d02662dc2fe7$var$promiseCtorString:
            return $0785d02662dc2fe7$var$promiseTag;
        case $0785d02662dc2fe7$var$setCtorString:
            return $0785d02662dc2fe7$var$setTag;
        case $0785d02662dc2fe7$var$weakMapCtorString:
            return $0785d02662dc2fe7$var$weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $0785d02662dc2fe7$var$isIndex(value, length) {
    length = length == null ? $0785d02662dc2fe7$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || $0785d02662dc2fe7$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $0785d02662dc2fe7$var$isIterateeCall(value, index, object) {
    if (!$0785d02662dc2fe7$var$isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? $0785d02662dc2fe7$var$isArrayLike(object) && $0785d02662dc2fe7$var$isIndex(index, object.length) : type == "string" && index in object) return $0785d02662dc2fe7$var$eq(object[index], value);
    return false;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $0785d02662dc2fe7$var$isMasked(func) {
    return !!$0785d02662dc2fe7$var$maskSrcKey && $0785d02662dc2fe7$var$maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $0785d02662dc2fe7$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $0785d02662dc2fe7$var$objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $0785d02662dc2fe7$var$toSource(func) {
    if (func != null) {
        try {
            return $0785d02662dc2fe7$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */ function $0785d02662dc2fe7$var$sampleSize(collection, n, guard) {
    var index = -1, result = $0785d02662dc2fe7$var$toArray(collection), length = result.length, lastIndex = length - 1;
    if (guard ? $0785d02662dc2fe7$var$isIterateeCall(collection, n, guard) : n === undefined) n = 1;
    else n = $0785d02662dc2fe7$var$baseClamp($0785d02662dc2fe7$var$toInteger(n), 0, length);
    while(++index < n){
        var rand = $0785d02662dc2fe7$var$baseRandom(index, lastIndex), value = result[rand];
        result[rand] = result[index];
        result[index] = value;
    }
    result.length = n;
    return result;
}
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $0785d02662dc2fe7$var$shuffle(collection) {
    return $0785d02662dc2fe7$var$sampleSize(collection, $0785d02662dc2fe7$var$MAX_ARRAY_LENGTH);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $0785d02662dc2fe7$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $0785d02662dc2fe7$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $0785d02662dc2fe7$var$isArrayLikeObject(value) && $0785d02662dc2fe7$var$hasOwnProperty.call(value, "callee") && (!$0785d02662dc2fe7$var$propertyIsEnumerable.call(value, "callee") || $0785d02662dc2fe7$var$objectToString.call(value) == $0785d02662dc2fe7$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0785d02662dc2fe7$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $0785d02662dc2fe7$var$isArrayLike(value) {
    return value != null && $0785d02662dc2fe7$var$isLength(value.length) && !$0785d02662dc2fe7$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $0785d02662dc2fe7$var$isArrayLikeObject(value) {
    return $0785d02662dc2fe7$var$isObjectLike(value) && $0785d02662dc2fe7$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $0785d02662dc2fe7$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $0785d02662dc2fe7$var$isObject(value) ? $0785d02662dc2fe7$var$objectToString.call(value) : "";
    return tag == $0785d02662dc2fe7$var$funcTag || tag == $0785d02662dc2fe7$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0785d02662dc2fe7$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $0785d02662dc2fe7$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $0785d02662dc2fe7$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0785d02662dc2fe7$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $0785d02662dc2fe7$var$isString(value) {
    return typeof value == "string" || !$0785d02662dc2fe7$var$isArray(value) && $0785d02662dc2fe7$var$isObjectLike(value) && $0785d02662dc2fe7$var$objectToString.call(value) == $0785d02662dc2fe7$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $0785d02662dc2fe7$var$isSymbol(value) {
    return typeof value == "symbol" || $0785d02662dc2fe7$var$isObjectLike(value) && $0785d02662dc2fe7$var$objectToString.call(value) == $0785d02662dc2fe7$var$symbolTag;
}
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $0785d02662dc2fe7$var$toArray(value) {
    if (!value) return [];
    if ($0785d02662dc2fe7$var$isArrayLike(value)) return $0785d02662dc2fe7$var$isString(value) ? $0785d02662dc2fe7$var$stringToArray(value) : $0785d02662dc2fe7$var$copyArray(value);
    if ($0785d02662dc2fe7$var$iteratorSymbol && value[$0785d02662dc2fe7$var$iteratorSymbol]) return $0785d02662dc2fe7$var$iteratorToArray(value[$0785d02662dc2fe7$var$iteratorSymbol]());
    var tag = $0785d02662dc2fe7$var$getTag(value), func = tag == $0785d02662dc2fe7$var$mapTag ? $0785d02662dc2fe7$var$mapToArray : tag == $0785d02662dc2fe7$var$setTag ? $0785d02662dc2fe7$var$setToArray : $0785d02662dc2fe7$var$values;
    return func(value);
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $0785d02662dc2fe7$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $0785d02662dc2fe7$var$toNumber(value);
    if (value === $0785d02662dc2fe7$var$INFINITY || value === -$0785d02662dc2fe7$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $0785d02662dc2fe7$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $0785d02662dc2fe7$var$toInteger(value) {
    var result = $0785d02662dc2fe7$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0785d02662dc2fe7$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($0785d02662dc2fe7$var$isSymbol(value)) return $0785d02662dc2fe7$var$NAN;
    if ($0785d02662dc2fe7$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $0785d02662dc2fe7$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($0785d02662dc2fe7$var$reTrim, "");
    var isBinary = $0785d02662dc2fe7$var$reIsBinary.test(value);
    return isBinary || $0785d02662dc2fe7$var$reIsOctal.test(value) ? $0785d02662dc2fe7$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0785d02662dc2fe7$var$reIsBadHex.test(value) ? $0785d02662dc2fe7$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0785d02662dc2fe7$var$keys(object) {
    return $0785d02662dc2fe7$var$isArrayLike(object) ? $0785d02662dc2fe7$var$arrayLikeKeys(object) : $0785d02662dc2fe7$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $0785d02662dc2fe7$var$values(object) {
    return object ? $0785d02662dc2fe7$var$baseValues(object, $0785d02662dc2fe7$var$keys(object)) : [];
}
$0785d02662dc2fe7$exports = $0785d02662dc2fe7$var$shuffle;


var $9e014d6baa31f77b$exports = {};
$9e014d6baa31f77b$exports = function storageAvailable(type) {
    try {
        var storage = window[type], x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return false;
    }
};


var $16ebf41e1ff962a7$exports = {};
$16ebf41e1ff962a7$exports = JSON.parse('[{"name":"Bloomberg","articles":[{"title":"How an American City Can Become a Manufacturing Hub","url":"https://www.bloomberg.com/news/articles/2026-05-07/allentown-pa-is-moving-past-the-billy-joel-song"},{"title":"UBS Fined \u20AC6 Million by Monaco Over Repeated Dirty Money Failures","url":"https://www.bloomberg.com/news/articles/2026-05-07/ubs-fined-6-million-by-monaco-over-repeated-dirty-money-failures"},{"title":"The Saudi Airline Preparing to Launch Just as Iran Upends Travel","url":"https://www.bloomberg.com/news/articles/2026-05-07/the-saudi-airline-preparing-to-launch-just-as-iran-upends-travel"}],"url":"http://www.bloomberg.com"},{"name":"Google News","articles":[{"title":"Live updates: Iran expected to respond Thursday to US proposal for ending war, source says - CNN","url":"https://access.workspace.google.com/remediate"},{"title":"Starmer Faces a Major Test in a Set of U.K. Elections: What to Know - The New York Times","url":"https://access.workspace.google.com/ServiceNotAllowed"},{"title":"Google News","url":"https://news.google.com/rss/articles/CBMikwFBVV95cUxQbklJQldhb09DWmNmLWJoelhNdFdPRV9yaXVJOGIwcDh3djN4MHJYUHpBWjdKaGhrdEhIbVN1RENmRXZIV21nT1VtWEdvNE50NTF0ZnBxRUxYSlN6V0oxZjhrdTB5T1Y1dWJqWWdnbTRRNTgybzRBMDJ3dE94bHYyVl95dUlLM3JHNmtSaUZXTEpnUFU"}],"url":"https://news.google.com"},{"name":"Associated Press","articles":[{"title":"Iran reviews US proposals as Trump threatens new wave of bombing unless deal is reached","url":"https://apnews.com/article/iran-us-israel-war-may-7-2026-fdc6d2ae9396377919c967746fa9996b"},{"title":"Pakistan issues warning on anniversary of 2025 clash with India","url":"https://apnews.com/article/pakistan-india-war-kashmir-anniversary-683ab7446c2f019f545d68ddd3e1a7f1"},{"title":"Polls open in UK local elections seen as referendum on Starmer","url":"https://apnews.com/article/uk-elections-starmer-labour-04241e4a566985eebe06715b9a63d94f"}],"url":"https://apnews.com/"},{"name":"CNN","articles":[{"title":"Ube craze is stressing farmers out | CNN","url":"https://www.cnn.com/2026/05/07/world/video/ube-purple-yam-the-philippines-stephanie-yang-hnk-vrtc-digvid"},{"title":"Debris blocks parts of highway after violent tornado | CNN","url":"https://www.cnn.com/2026/05/07/weather/video/brookhaven-mississippi-tornado-hnk-digvid"},{"title":"Inside the town Ozempic built","url":"https://www.cnn.com/2026/05/07/business/novo-nordisk-ozempic-wegovy-kalundborg"}],"url":"http://us.cnn.com"},{"name":"BBC News","articles":[{"title":"Shell profits rise as Iran war pushes oil prices higher","url":"https://www.bbc.co.uk/news/articles/ce3p0x54drwo"},{"title":"\'Man in smart glasses filmed me in London then told me to pay\'","url":"https://www.bbc.co.uk/news/articles/cwy87wqz0q9o"},{"title":"Ukraine is a global surrogacy hub - but that could be about to end","url":"https://www.bbc.co.uk/news/articles/clyp4kp687go"}],"url":"https://www.bbc.co.uk/news"},{"name":"The Huffington Post","articles":[{"title":"Trump Goes On Long Tangent About Why He Kept Calling Melania By The Wrong Name","url":"https://www.huffpost.com/entry/donald-trump-melania-trump-wrong-name_n_69fc2c6be4b06e786e3c5410"},{"title":"Jeffrey Epstein\u2019s Alleged Suicide Note Just Went Public","url":"https://www.huffpost.com/entry/jeffrey-epstein-purported-suicide-note-released_n_69fc0458e4b06e786e3c4530"},{"title":"TikTok Trend Using Charlie Kirk Assassination Audio Draws Swift Backlash From TPUSA","url":"https://www.huffpost.com/entry/charlie-kirk-assassination-sound-tiktok-trend_n_69fbde65e4b065a1677bf54c"}],"url":"http://www.huffingtonpost.com"},{"name":"ESPN","articles":[{"title":"Wolves fail to heed Edwards\' warning, come out \'cool\' in rout - ESPN","url":"https://www.espn.com/nba/story/_/id/48700497/wolves-fail-heed-edwards-warning-come-cool-rout"},{"title":"Spurs bounce back, beat Timberwolves by 38 to even series - ESPN","url":"https://www.espn.com/nba/story/_/id/48700056/spurs-rebound-game-2-hand-timberwolves-their-worst-postseason-loss-franchise-history"},{"title":"Sabres take Game 1 as power play finally emerges","url":"https://www.espn.com/nhl/story/_/id/48699500/sabres-beat-canadiens-game-1-strength-power-play"}],"url":"https://www.espn.com"},{"name":"Entertainment Weekly","articles":[{"title":"Sally Field remembers Robin Williams trying to make her laugh on \'Mrs. Doubtfire\': \'It wasn\'t funny\'","url":"https://ew.com/sally-field-says-robin-williams-wasnt-funny-on-mrs-doubtfire-set-11969040"},{"title":"Goldie Hawn responds to Meryl Streep\'s charge that Hawn is always late to set","url":"https://ew.com/goldie-hawn-responds-to-meryl-streep-saying-she-is-always-late-to-set-11969035"},{"title":"Khlo\xe9 Kardashian says she was drugged at Coachella and locked herself in a bathroom for hours","url":"https://ew.com/khloe-kardashian-says-she-was-drugged-at-coachella-in-2015-11969034"}],"url":"http://www.ew.com"},{"name":"USA Today","articles":[{"title":"Suspect arrested in deadly party shooting by Oklahoma lake","url":"https://www.usatoday.com/story/news/nation/2026/05/07/oklahoma-lake-party-shooting-suspect-arrest/89969173007/"},{"title":"Dolly Parton, Zayn, more nixing tour dates. See 2026 cancellations","url":"https://www.usatoday.com/story/entertainment/music/2026/05/06/canceled-tours-2026-dolly-parton-post-malone/89950432007/"}],"url":"http://www.usatoday.com/news"},{"name":"MS Now","articles":[{"title":"New Trump counterterrorism strategy expands targets to antifa and Iran","url":"https://www.ms.now/news/new-trump-counterterrorism-strategy-expands-targets-to-antifa-and-iran"},{"title":"Justice Department can keep 2020 election ballots seized from Georgia\u2019s Fulton County, judge rules","url":"https://www.ms.now/news/justice-department-can-keep-2020-election-ballots-seized-from-georgias-fulton-county"},{"title":"Jeffrey Epstein\u2019s purported suicide note made public","url":"https://www.ms.now/news/jeffrey-epsteins-purported-suicide-note-made-public"}],"url":"http://www.ms.now"},{"name":"CBS News","articles":[{"title":"Live Updates: Trump threatens Iran strikes, says too soon for new direct talks after reporting \\"great progress\\"","url":"https://www.cbsnews.com/live-updates/iran-war-trump-progress-peace-deal-strait-of-hormuz/"},{"title":"5/6: CBS Evening News","url":"https://www.cbsnews.com/video/050626-cbs-evening-news/"},{"title":"How hantavirus may have spread aboard a cruise ship, according to health experts","url":"https://www.cbsnews.com/news/hantavirus-spread-cruise-ship-outbreak-health-experts/"}],"url":"http://www.cbsnews.com"},{"name":"Fox Sports","articles":[{"title":"Luis Suarez Explains Why He Re-Signed Alongside Lionel Messi At Inter Miami","url":"https://www.foxsports.com/stories/soccer/luis-suarez-explains-why-he-signed-new-contract-alongside-lionel-messi-at-inter-miami-with-39-year-old-striker-accepting-some-bench-duty-in-mls"},{"title":"Mbapp\xe9, France Ends Croatia&#39;s Dream: 2018 Final Joins Top World Cup Moments","url":"https://www.foxsports.com/stories/soccer/world-cup-100-best-moments-messi-maradona-ronaldo-pele-mbappe-usa"},{"title":"Brief History Of The 1994 World Cup In The United States","url":"https://www.foxsports.com/stories/soccer/1994-world-cup-united-states-history-host"}],"url":"http://www.foxsports.com"},{"name":"NBC News","articles":[{"title":"Trump asks appeals court to pause ruling in E. Jean Carroll case pending a Supreme Court decision","url":"https://www.nbcnews.com/politics/donald-trump/trump-asks-appeals-court-pause-ruling-e-jean-carroll-case-rcna343948"},{"title":"France moves aircraft carrier group toward Strait of Hormuz for possible defensive mission","url":"https://www.nbcnews.com/world/europe/france-moves-aircraft-carrier-group-strait-hormuz-possible-defensive-m-rcna343963"},{"title":"Chief Justice John Roberts says justices aren\u2019t \u2018political actors\u2019","url":"https://www.nbcnews.com/politics/supreme-court/chief-justice-john-roberts-says-justices-are-not-political-actors-rcna343958"}],"url":"http://www.nbcnews.com"},{"name":"TechRadar","articles":[{"title":"\'A foundational block of modern cybercrime\': The inside story of a 15,000+ website network using popular ad trackers to peddle AI investment scams","url":"https://www.techradar.com/pro/a-foundational-block-of-modern-cybercrime-the-inside-story-of-a-15-000-website-network-using-popular-ad-trackers-to-peddle-ai-investment-scams"},{"title":"\'It just vanished\': Millions at risk as Android trojans use devious trick to \'magically\' disappear once installed","url":"https://www.techradar.com/pro/security/it-just-vanished-millions-at-risk-as-android-trojans-use-devious-trick-to-magically-disappear-once-installed"},{"title":"\'Not just an aircraft\': US Navy MQ-25 Stingray drone hit a major milestone with maiden flight \u2014 largest US UAV ever built set to become world\'s first autonomous tanker to take flight from an aircraft carrier and maybe feature in a Top Gun movie one day","url":"https://www.techradar.com/pro/not-just-an-aircraft-us-navy-mq-25-stingray-drone-hit-a-major-milestone-with-maiden-flight-largest-us-uav-ever-built-set-to-become-worlds-first-autonomous-tanker-to-take-flight-from-an-aircraft-carrier-and-maybe-feature-in-a-top-gun-movie-one-day"}],"url":"https://www.techradar.com"},{"name":"ABC News","articles":[{"title":"Runner competing in 250-mile ultramarathon dies after having medical emergency","url":"https://abcnews.com/US/wireStory/runner-competing-250-mile-arizona-ultramarathon-dies-after-132730370"},{"title":"Electrical fire to keep theater that hosts \'The Book of Mormon\' closed through May 17","url":"https://abcnews.com/Entertainment/wireStory/electrical-fire-broadway-theater-hosts-book-mormon-closed-132729594"}],"url":"https://abcnews.go.com"},{"name":"The Washington Post","articles":[{"title":"Court releases purported suicide note from Jeffrey Epstein","url":"https://www.washingtonpost.com/national-security/2026/05/06/jeffrey-epstein-suicide-note/"},{"title":"Lutnick testifies before congressional panel investigating Epstein","url":"https://www.washingtonpost.com/politics/2026/05/06/lutnick-testifies-before-congressional-panel-investigating-epstein/"},{"title":"Judge denies request to return 2020 ballots seized from Fulton County, Georgia","url":"https://www.washingtonpost.com/national-security/2026/05/06/fulton-ballots-investigation-trump/"}],"url":"https://www.washingtonpost.com"},{"name":"New York Magazine","articles":[{"title":"What We Know About the Cruise Ship Hantavirus Outbreak","url":"https://nymag.com/intelligencer/article/hantavirus-outbreak-cruise-ship-hondius-what-we-know.html"}],"url":"https://nymag.com/"},{"name":"The Verge","articles":[{"title":"Musk\u2019s biggest loyalist became his biggest liability","url":"https://www.theverge.com/ai-artificial-intelligence/925665/musk-altman-trial-shivon-zilis-testimony"}],"url":"http://www.theverge.com"}]');


const $b7ac0cf7b7632c81$var$log = (0, (/*@__PURE__*/$parcel$interopDefault($7bTWQ)))("lore");
// Delete viewed links that are old to avoid hitting the localStorage limit.
function $b7ac0cf7b7632c81$var$pruneViewedLinks() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9e014d6baa31f77b$exports)))("localStorage")) return;
    const now = new Date();
    const viewed = JSON.parse(localStorage.getItem("viewed")) || {};
    for(const link in viewed){
        const viewedTime = new Date(viewed[link]);
        const daysOld = (now - viewedTime) / 1000 / 60 / 60 / 24;
        if (daysOld > 7) delete viewed[link];
    }
    $b7ac0cf7b7632c81$var$log("Number of viewed links:", Object.keys(viewed).length);
    try {
        localStorage.setItem("viewed", JSON.stringify(viewed));
    } catch (error) {
        localStorage.removeItem("viewed");
    }
}
function $b7ac0cf7b7632c81$var$getSourceCard(name, homepageUrl, articles, viewed) {
    const logo = `<h6 class="deep-orange-text darken-2">${name}</h6>`;
    let card = `<div class="col s12 offset-m1 m10 offset-l1 l10">
                    <ul class="collection">
                        <li class="collection-item">
                            <div class="center-align">
                                <a href="${homepageUrl}" target="_blank">
                                   ${logo}
                                </a>
                            </div>
                        </li>`;
    const addedTitles = []; // prevent duplicate links
    for(let i = 0; i < 3 && i < articles.length; i++){
        if (addedTitles.indexOf(articles[i].title) !== -1 || Object.prototype.hasOwnProperty.call(viewed, articles[i].url)) continue;
        addedTitles.push(articles[i].title);
        card += `<li class="collection-item">
                     <a class="article"
                         href="${articles[i].url}"
                         target="_blank">
                         ${articles[i].title}
                     </a>
                 </li>`;
    }
    return addedTitles.length ? `${card}</ul></div>` : null;
}
let $b7ac0cf7b7632c81$var$hideViewed = true;
if ((0, (/*@__PURE__*/$parcel$interopDefault($9e014d6baa31f77b$exports)))("localStorage") && localStorage.getItem("viewOnce") === "off") $b7ac0cf7b7632c81$var$hideViewed = false;
else location.search.slice(1).split("&").forEach((pair)=>{
    const [key, value] = pair.split("=");
    if (key === "view-once" && value === "off") $b7ac0cf7b7632c81$var$hideViewed = false;
});
if (!$b7ac0cf7b7632c81$var$hideViewed) document.getElementById("view-once").checked = false;
else {
    let throttle = false;
    var $b7ac0cf7b7632c81$var$checkVisibility = function() {
        if (throttle) return;
        const bottom = window.innerHeight || document.documentElement.clientHeight;
        const articles = document.querySelectorAll("a.article:not(.viewed)");
        if (articles.length === 0) window.removeEventListener("scroll", $b7ac0cf7b7632c81$var$checkVisibility);
        const hrefs = {};
        for(let i = 0; i < articles.length; i++){
            const rect = articles[i].getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= bottom) {
                const href = articles[i].getAttribute("href");
                hrefs[href] = new Date().toISOString();
                // To avoid checking it again
                articles[i].classList.add("viewed");
            }
            if (rect.bottom > bottom) break;
        }
        if (Object.keys(hrefs).length) {
            let viewed = {};
            try {
                viewed = JSON.parse(localStorage.getItem("viewed")) || viewed;
            } catch (err) {} // eslint-disable-line no-empty
            Object.assign(viewed, hrefs);
            try {
                localStorage.setItem("viewed", JSON.stringify(viewed));
            } catch (error) {
                localStorage.removeItem("viewed");
            }
        }
        throttle = true;
        setTimeout(function() {
            throttle = false;
        }, 200);
    };
    window.addEventListener("scroll", $b7ac0cf7b7632c81$var$checkVisibility);
}
document.getElementById("loading-bar").style.visibility = "visible";
const $b7ac0cf7b7632c81$var$headlines = (0, (/*@__PURE__*/$parcel$interopDefault($0785d02662dc2fe7$exports)))($16ebf41e1ff962a7$exports);
let $b7ac0cf7b7632c81$var$viewed = {};
if ($b7ac0cf7b7632c81$var$hideViewed) try {
    $b7ac0cf7b7632c81$var$viewed = JSON.parse(localStorage.getItem("viewed")) || $b7ac0cf7b7632c81$var$viewed;
} catch (e) {} // eslint-disable-line no-empty
const $b7ac0cf7b7632c81$var$main = document.getElementById("main");
const $b7ac0cf7b7632c81$var$endMessage = document.getElementById("end-message");
for (let source of $b7ac0cf7b7632c81$var$headlines){
    const card = $b7ac0cf7b7632c81$var$getSourceCard(source.name, source.url, source.articles, $b7ac0cf7b7632c81$var$viewed);
    if (card) {
        const row = document.createElement("div");
        row.innerHTML = `<div class="row">${card}</div>`;
        $b7ac0cf7b7632c81$var$main.insertBefore(row, $b7ac0cf7b7632c81$var$endMessage);
    }
}
// Hide the loading bar without causing the rows to move up
// slightly
document.getElementById("loading-bar").style.visibility = "hidden";
// Unhide the end message and footer
$b7ac0cf7b7632c81$var$endMessage.classList.remove("hide");
document.getElementById("footer").classList.remove("hide");
if ($b7ac0cf7b7632c81$var$hideViewed) $b7ac0cf7b7632c81$var$checkVisibility();
$b7ac0cf7b7632c81$var$pruneViewedLinks();
document.getElementById("view-once").addEventListener("change", function() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9e014d6baa31f77b$exports)))("localStorage")) try {
        localStorage.setItem("viewOnce", this.checked ? "on" : "off");
    } catch (error) {
        localStorage.removeItem("viewed");
    }
    else {
        const url = location.origin + (this.checked ? "" : "?view-once=off");
        location.href = url;
    }
});


//# sourceMappingURL=index.b0fe9166.js.map
